/*==============================================================================================
Nombre del archivo: estudiantes.js
Descripción: Funciones para controlar las acciones en la vista de estudiantes
--------------------------------------------------------------------------------------------
Autor: Alexander Gallego Lozano
Fecha: 2022-07-20
===============================================================================================*/
(function (window, document, $) {
    'use strict';
    $(document).ready(function() {
        $(".select2").select2({
            theme: "bootstrap-5",
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
        });
    });

    $( "#identificacion" ).change(function() {
        consulta_datos_personales();
    });

    $( "#generar_transaccion" ).click(function() {
        generar_transaccion();
    });

    $('#data_facturacion').DataTable({
        "processing"    : true,
        "serverSide"    : false,
        "lengthMenu"    : [ [10, 25, 50, -1], [10, 25, 50, "Todos"] ],
        "bLengthChange" : false,
        "searching"     : false,
        language: {
            "sProcessing"     : "Procesando...",
            "sLengthMenu"     : "Mostrar _MENU_ registros",
            "sZeroRecords"    : "No se encontraron resultados",
            "sEmptyTable"     : "Ningún dato disponible en esta tabla",
            "sInfo"           : "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            "sInfoEmpty"      : "Mostrando registros del 0 al 0 de un total de 0 registros",
            "sInfoFiltered"   : "(filtrado de un total de _MAX_ registros)",
            "sInfoPostFix"    : "",
            "sSearch"         : "Buscar:",
            "sUrl"            : "",
            "sInfoThousands"  : ",",
            "sLoadingRecords" : "Cargando...",
            "oPaginate": {
                "sFirst"    : "Primero",
                "sLast"     : "Último",
                "sNext"     : "Siguiente",
                "sPrevious" : "Anterior"
            },
            buttons: {
                pageLength: {
                    '_' : "Motrando %d registros",
                    '-1': "Todos"
                },
                colvis: 'Columnas'
            },
            "oAria": {
                "sSortAscending"  : " : Activar para ordenar la columna de manera ascendente",
                "sSortDescending" : " : Activar para ordenar la columna de manera descendente"
            }
        },
        "responsive" : true,
        "autoWidth"  : false,
        ajax: {
            url: ruta_consulta_matricula,
            type: 'POST',
                'headers': {
                'X-CSRF-TOKEN': token
            },
            async: false,
            data:function (d) {
                return $.extend( {}, d, {
                    "id_estudiante" : $('#id_estudiante').val()
                })
            },
            statusCode: {
                401: function() {
                    window.location.href = '/';
                }
            },
            error: function (xhr, error, code)
            {
                console.log(xhr);
                console.log(code);
            }
        },
        "columns" : [
            {"data" : "valor_ordinario", render: function(data, type, row) {
                        if (data) {
                            var response = '<div style="text-align: end;">' + row.fecha_ordinaria + '<br/>' + $.fn.dataTable.render.number( '.', ',', 2, '$ ' ).display(data) + '<br/>' + 'Descuento: ' + $.fn.dataTable.render.number( '.', ',', 2, '$ ' ).display(row.valor_descuento) + '</div>';
                            if ($('#valor').val() == 0) {
                                $('#valor').val(data);
                                $('#valor_display').val($.fn.dataTable.render.number( '.', ',', 2, '$ ' ).display(data-row.valor_descuento));
                                                            }
                            return response;
                        } else {
                            return '-';
                        }
                    }
            },
            {"data" : "valor_extraordinario", render: function(data, type, row) {
                        if (data) {
                            var response = '<div style="text-align: end;">' + row.fecha_extraordinaria + '<br/>' + $.fn.dataTable.render.number( '.', ',', 2, '$ ' ).display(data) + '</div>';
                            if ($('#valor').val() == 0) {
                                $('#valor').val(data);
                                $('#valor_display').val($.fn.dataTable.render.number( '.', ',', 2, '$ ' ).display(data));
                            }
                            return response;
                        } else {
                            return '-';
                        }
                    }
            },
        ],
    });
})(window, document, jQuery);

function consulta_datos_personales() {
    try {
        $('.loader_icon').show();
        $.ajax({
            async: true,
            url: ruta_consulta_datos_personales,
            type: 'POST',
            data: { "identificacion" : $('#identificacion').val() },
            success: function(data) {
                $('.loader_icon').hide();

                limpiar_formulario();

                if (typeof data !== 'undefined') {
                    $('#id_estudiante').val(data.id_estudiante);
                    $('#nombres_apellidos').val(data.nombres_apellidos);
                    $('#correo').val(data.correo);
                    $('#celular').val(data.celular);
                    $('#id_matricula').val(data.id_matricula);
                    $('#id_periodo').val(data.periodo);
                    $('#programa').val(data.programa);
                    $('#id_tipo_documento_identidad').val(data.id_tipo_documento_identidad).trigger('change');
                    $('#data_facturacion').DataTable().ajax.reload();
                }
            },
            error: function (xhr, error, code, data) {
                limpiar_formulario();
                console.log(xhr);
            },
            'headers': {
                'X-CSRF-TOKEN': token
            }
        }, 'json');
    } catch (error) {
      console.error(error);
    }
}

function limpiar_formulario() {
    $('#id_estudiante').val(0);
    $('#id_matricula').val(0);
    $('#nombres_apellidos').val('');
    $('#correo').val('');
    $('#celular').val('');
    $('#id_periodo').val('');
    $('#programa').val('');
    $('#id_tipo_documento_identidad').val('').trigger('change');
    $('#id_matricula').val(0);
}

function generar_transaccion() {
    try {
        if ($('#id_matricula').val() == 0) {
            $('#msg_error_transaccion').html('#0202 - Debe seleccionar un estudiante valido.');
            $('#error_transaccion').show("slow").delay(6000).hide("slow");
            return false;
        }

        if ($('#valor').val() == 0) {
            $('#msg_error_transaccion').html('#0196 - El valor a pagar no puede ser 0.');
            $('#error_transaccion').show("slow").delay(6000).hide("slow");
            return false;
        }

        if (!$("#acepta_tratamiento").is(':checked')) {
            $('#msg_error_transaccion').html('#0000 - Debe aceptar y autorizar el tratamiento de sus datos personales.');
            $('#error_transaccion').show("slow").delay(6000).hide("slow");
            return false;
        }

        if (typeof $('input:radio[name=medio_pago]:checked').val() === 'undefined') {
            $('#msg_error_transaccion').html('#0190 - Debe seleccionar un canal de recaudo.');
            $('#error_transaccion').show("slow").delay(6000).hide("slow");
            return false;
        }

        $('.loader_icon').show();
        if ($('input:radio[name=medio_pago]:checked').val() == 4) {
            window.location.href = "/uniempresarial/estudiantes/recibo_matricula." + $('#id_matricula').val();
            exit();
        }
        $.ajax({
            async: true,
            url: ruta_generar_transaccion,
            type: 'POST',
            data: {
                "tipo_recaudo" : 0,
                "id_matricula" : $('#id_matricula').val(),
                "id_estudiante": $('#id_estudiante').val(),
                "medio_pago"   : $('input:radio[name=medio_pago]:checked').val(),
            },
            success: function(data) {
                if (typeof data != 'undefined') {
                    if (data.codigo == '0000') {
                        if ($('input:radio[name=medio_pago]:checked').val() == 1) {
                            postForm(data.url, {'id_transaccion': data.id_transaccion, 'token': data.token});
                            $('.loader_icon').hide();
                        }
                        else
                            window.location.href = data.url;
                    } else {
                        $('.loader_icon').hide();
                        $('#msg_error_transaccion').html('#' + data.codigo + ' - ' + data.msg);
                        $('#error_transaccion').show("slow").delay(6000).hide("slow");
                        console.log(data);
                    }
                }
            },
            error: function (xhr, error, code, data) {
                $('.loader_icon').hide();
                $('#msg_error_transaccion').html('#0000 - Se produjo un error creando la transacción');
                $('#error_transaccion').show("slow").delay(6000).hide("slow");
                console.log(xhr);
            },
            'headers': {
                'X-CSRF-TOKEN': token
            }
        }, 'json');
    } catch (error) {
      console.log(error);
    }
}

function postForm(path, params, method) {
    method = method || 'post';

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}
